/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file handleTrackerUnmount internal helper function
 * @author Roland Scott
 * @module react-async-hook\internal\use-async\handle-tracker-unmount
 */

import { noOp } from "./no-op";
import { IAsyncFunction } from "../";
import { ExecutorRef, IgnorerRef, StateUpdaterRef } from "../types";

/**
 * Handle tracker unmount by turning certain functions into no-ops
 */
export function handleTrackerUnmount<TAsync extends IAsyncFunction>(
	execute: ExecutorRef<TAsync>,
	ignore: IgnorerRef,
	updateState: StateUpdaterRef,
): void {
	execute.current = noOp as any;
	ignore.current = noOp;
	updateState.current = noOp;
}
